import ComponentHelper from '../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './dialog-modal.css';

class DialogModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		let { type, showCancelButton, cancelBtnText, confirmBtnText, text, title } = props;
		this.data = {
			title: title || '',
			text: text || '',
			confirmBtnText: confirmBtnText || 'Ok',
			cancelBtnText: cancelBtnText || 'Cancel',
			showCancelButton: showCancelButton === true ? true : false,
			type: type || null
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	render() {
		let { isOpen } = this.props;
		let { type, showCancelButton, cancelBtnText, confirmBtnText, text, title } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				isOpen={isOpen}
				className="dialog-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
				ariaHideApp={false}
			>
				{type && (
					<div className="type-ctn">
						{type === 'warning' && <i className="mdi mdi-alert-circle-outline" />}
						{type === 'info' && <i className="mdi mdi-information-outline" />}
						{type === 'success' && <i className="mdi mdi-checkbox-marked-circle-outline" />}
						{type === 'error' && <i className="mdi mdi-close-octagon-outline" />}
					</div>
				)}
				<div className="dialog-title">{title}</div>
				<div className="dialog-msg">{text}</div>
				<div className="hbox vcenter hcenter">
					{showCancelButton && (
						<button className="btn cancel-btn" onClick={this.props.onCancel}>
							{cancelBtnText}
						</button>
					)}
					<button className="btn primary" onClick={this.props.onConfirm}>
						{confirmBtnText}
					</button>
				</div>
			</Modal>
		);
	}
}
export default DialogModal;



// WEBPACK FOOTER //
// ./src/components/dialog-modal/DialogModal.js